<template>
  <EmptyContainer>
    <slot/>
    <NuxtPage/>
  </EmptyContainer>
</template>
